"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _customerSource = require("@/api/customer-source");
var _vuePropertyDecorator = require("vue-property-decorator");
var _FilterOrder = require("./FilterOrder.vue");
var _order = require("@/types/order");
var _paymentType = require("@/types/paymentType");
var OrderInfoForm = /*#__PURE__*/function (_Vue) {
  function OrderInfoForm() {
    var _this;
    (0, _classCallCheck2.default)(this, OrderInfoForm);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, OrderInfoForm, [].concat(args));
    (0, _defineProperty2.default)(_this, "orderProgress", void 0);
    (0, _defineProperty2.default)(_this, "order", void 0);
    (0, _defineProperty2.default)(_this, "disabled", void 0);
    (0, _defineProperty2.default)(_this, "compare", void 0);
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "SaleChannel", []);
    (0, _defineProperty2.default)(_this, "PaymentType", _paymentType.PaymentType);
    (0, _defineProperty2.default)(_this, "deliveryPartnerTrans", _order.DeliveryPartnerTrans);
    (0, _defineProperty2.default)(_this, "DeliveryPartner", _order.DeliveryPartner);
    (0, _defineProperty2.default)(_this, "PackageStatus", _order.PackageStatus);
    (0, _defineProperty2.default)(_this, "ExportStatus", _order.ExportStatus);
    (0, _defineProperty2.default)(_this, "ReturnStatus", _order.ReturnStatus);
    (0, _defineProperty2.default)(_this, "OrderStatus", _FilterOrder.OrderStatus);
    (0, _defineProperty2.default)(_this, "rules", {
      saleChannelId: {
        required: true,
        message: "Field is required",
        trigger: "submit"
      }
    });
    return _this;
  }
  (0, _inherits2.default)(OrderInfoForm, _Vue);
  return (0, _createClass2.default)(OrderInfoForm, [{
    key: "created",
    value: function created() {
      this.fetchSaleChannel();
    }
  }, {
    key: "fetchSaleChannel",
    value: function () {
      var _fetchSaleChannel = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _customerSource.customerSourceApi.findAll({});
            case 2:
              res = _context.sent;
              this.SaleChannel = res.data.customerSources;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchSaleChannel() {
        return _fetchSaleChannel.apply(this, arguments);
      }
      return fetchSaleChannel;
    }()
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], OrderInfoForm.prototype, "orderProgress", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], OrderInfoForm.prototype, "order", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], OrderInfoForm.prototype, "disabled", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], OrderInfoForm.prototype, "compare", void 0);
OrderInfoForm = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], OrderInfoForm);
var _default = exports.default = OrderInfoForm;